import FlexDetails from './FlexDetails';
import FlexSessionService from '../shared/FlexSessionService';


window.tnew.page.initialize = ({ token, packageId, reloadKey }) => {
  const service = new FlexSessionService(token, packageId);

  new FlexDetails(token, packageId, reloadKey, service);
};



// WEBPACK FOOTER //
// ./V7/packages/flex/details/flex-details.js